
import relatedProducts from '../../../mocks/relatedProducts';

const RelatedProducts = () => {
  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold text-gray-900 mb-8">관련 제품</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {relatedProducts.map((product) => (
          <a
            key={product.id}
            href={product.link}
            className="group bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all cursor-pointer"
          >
            <div className="w-full h-48 bg-gray-50 overflow-hidden">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-teal-600 font-medium">{product.category}</span>
              <h3 className="text-base font-semibold text-gray-900 mt-2 mb-3 line-clamp-2">
                {product.name}
              </h3>
              <div className="flex items-baseline gap-2">
                <span className="text-lg font-bold text-teal-600">구매협의</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
